import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Icon from "react-native-vector-icons/FontAwesome";
import { stylesColors } from "../../utils/publicVariables";
import { useHistory } from "react-router-dom";
import { AUTH_FETCH, AUTH_RESOLVE, AUTH_REJECT, AUTH_CANCEL } from '../../store/types/authTypes';
import { serverRequest } from '../../utils/serverRequest';
import { useDispatch, useSelector } from 'react-redux';

const { blue } = stylesColors;

const classes = {
	container: {
		// paddingTop: "2rem"
	}
};

const Login = () => {

	const { push } = useHistory();
	const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { error, status } = useSelector(state => state.auth);
	const dispatch = useDispatch();
	
	useEffect(() => {
		dispatch({ type: AUTH_CANCEL })
	}, [dispatch])

	const handleLogin = async (e) => {
    try {
      e.preventDefault();
      dispatch({ type: AUTH_FETCH});
      const endpoint = '/customer/user.json';
			const response = await serverRequest().get(endpoint, {email, password});
			const newemail = response.data.data.email
			const newpassword = response.data.data.password
			if(newemail !== email || newpassword !== password) throw new Error({name: 'authError', message: "wrong email or password!"})
      if(response.data.status === 'success'){
        dispatch({ type: AUTH_RESOLVE, payload: response.data.data });
        push('/dashboard');
      } 
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        dispatch({ type: AUTH_REJECT, payload: error.response.data.error });
      } else if (error.request) {
        // The request was made but no response was received
        dispatch({ type: AUTH_REJECT, payload: "Something went wrong, please try again" });
      } else {
        // Something happened in setting up the request that triggered an Error
        dispatch({ type: AUTH_REJECT, payload: "Something went wrong, please try again" });
      }
    }
  }

	return (
		<div style={classes.container}>
			<h2 className="mb-3">Login</h2>
			<h6 className="mb-3">Welcome back</h6>
			<Form>
				<Form.Group controlId="loginEmail">
					<Form.Control type="email" onChange={e => setEmail(e.target.value)} placeholder="Enter email" />
				</Form.Group>

				<Form.Group controlId="loginPassword">
					<Form.Control type="password" onChange={e => setPassword(e.target.value)} placeholder="Password" />
				</Form.Group>

				<div className="d-flex justify-content-between">
					<Form.Group controlId="loginCheckbox">
						<Form.Check type="checkbox" label="Remember me" />
					</Form.Group>
					<p className="text-warning">Forgot Password?</p>
				</div>

				<Button variant="primary" onClick={handleLogin} disabled={status === 'loading'} block>
					{status === 'loading'?"Loading...":"Sign In"}
				</Button>

				{error?(
					<div className="bg-danger p-2 mt-2">
						{typeof error === 'object'?(
							Object.keys(error).map( key =><p style={{color:'white'}} key={key}>{error[key]}</p>)
						):error}
					</div>
				):null}

				<p className="mt-3">Login With</p>
				<Button variant="light" block>
					<Icon name="google" size={20} color={blue} className="mr-2" /> Google
				</Button>
				<Button variant="light" block>
					<Icon name="facebook" size={20} color={blue} className="mr-2" />{" "}
					Facebook
				</Button>
			</Form>
		</div>
	);
};

export default Login;
